import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import React from 'react';
import '../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import { useTheme } from '../hooks/useTheme.js';
import { Box } from '../Box/index.js';

var TabListContainer = React.forwardRef(function (_a, ref) {
    var look = _a.look, divider = _a.divider, showMask = _a.showMask, children = _a.children, props = __rest(_a, ["look", "divider", "showMask", "children"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var forwardProps = handleStyleProps(__assign({ look: look, divider: divider, showMask: showMask }, props), { themeKey: "tabListContainer" });
    return (jsx(Box, __assign({ ref: ref }, forwardProps, { children: children })));
});
TabListContainer.displayName = "TabListContainer";

export { TabListContainer };
//# sourceMappingURL=TabListContainer.js.map
